"use client";

import React from "react";
import SideRailImage from "../SideRailImage";
import { PartialPartner } from "@/common/partner/types";
import useProgramRedesignTraffic from "@/monarch/rules/programRedesignTraffic/useProgramRedesignTraffic";

type SideRailImageTitleProps = {
  title?: string;
  partners: PartialPartner[];
};

const SideRailImageTitle = ({ title, partners }: SideRailImageTitleProps) => {
  const { sideRailImageTitle } = useProgramRedesignTraffic();
  const { isDarkMode, isHorizontal } = sideRailImageTitle || {};
  const partner = partners[0]?.name;
  title = title || "What to expect";
  const height = isHorizontal ? 120 : 220;

  return (
    <div
      className={`p-4 border rounded-[8px] shadow w-full max-w-md mx-auto ${
        isDarkMode ? "bg-primary" : "bg-white"
      }`}
    >
      <p
        className={`text-xl font-extrabold italic ${isDarkMode ? "text-white" : "text-primary"}`}
      >
        {title}
      </p>
      <div
        className={`flex gap-4 ${
          isHorizontal ? "flex-row items-center" : "flex-col items-start"
        }`}
      >
        <div className={isHorizontal ? "basis-1/2" : "w-full"}>
          <p
            className={`text-md ${isDarkMode ? "text-white" : "text-primary"}`}
          >
            Get <strong>unlimited access</strong> to all{" "}
            <strong>course materials</strong>,{" "}
            <strong>graded assignments</strong>, and{" "}
            <strong>certificate</strong>
            {partner ? <span> from [{partner}].</span> : ""}
          </p>
        </div>
        <div className={isHorizontal ? "basis-1/2" : "w-full"}>
          <SideRailImage height={height} />
        </div>
      </div>
    </div>
  );
};

export default SideRailImageTitle;
